import { connect } from 'react-redux';
import View from './EducationGoalsCRUDView';
import { educationGoalsSelector } from '../../../GoalsCRUDSelector';
import * as childrenSelector from '../../../ChildrenInfoWorkflow/ChildrenInfoWorkflowSelector';
import { fetchData } from '../../../AdvWorkflow/AdvWorkflowActions';
import {
  isPopulatedSelector,
  currentClientId,
  iterator,
  selectedGoalIdSelector,
} from '../../../AdvWorkflow/AdvWorkflowSelector';
import { onGoalEdit, onAddNewGoal, onGoalDelete } from './EducationGoalsCRUDActions';

export const getDetails = (goal, educationTypeOptions) => {
  if (goal.IsSpecificCollege) {
    return goal.SpecificCollegeName;
  }
  return educationTypeOptions.reduce((acc, current) => {
    if (current.value === goal.EducationType) {
      return current.label.split(/[ ][\\(]/)[0];
    }
    return acc;
  }, '-');
};

const mapStateToProps = (state, ownProps) => ({
  educationTypeOptions: childrenSelector.getEducationTypeOptions(state, ownProps),
  educationGoals: educationGoalsSelector(state, ownProps),
  clientId: currentClientId(state, ownProps),
  isPopulated: isPopulatedSelector(state, ownProps),
  iterator: iterator(state, ownProps),
  selectedGoalId: selectedGoalIdSelector(state),
});

const mapDispatchToProps = dispatch => ({
  getDetails,
  onAddNewGoal: (workflowId, clientId) => () => {
    dispatch(onAddNewGoal(workflowId, clientId));
  },
  onGoalEdit: (educationGoal, workflowId, clientId) => () => {
    dispatch(onGoalEdit(educationGoal, workflowId, clientId));
  },
  fetchData: (workflowId, clientId) => {
    dispatch(fetchData(workflowId, clientId, ['EducationGoals'], true));
  },
  onGoalDelete: (goalId, educationGoals, workflowId, clientId) => {
    dispatch(onGoalDelete(goalId, educationGoals, workflowId, clientId));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);
